import { render } from "./Add.vue?vue&type=template&id=d1c5e5f0&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=d1c5e5f0&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c5e5f0"],['__file',"resources/js/pages/payments/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1c5e5f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1c5e5f0', __exports__)) {
    console.log('reload')
    api.reload('d1c5e5f0', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=d1c5e5f0&scoped=true", () => {
    console.log('re-render')
    api.rerender('d1c5e5f0', render)
  })

}


export default __exports__